(function () {
  if (window.__marlopCartReady) return;
  window.__marlopCartReady = true;

  var ROOT = '#MarlopCart';
  var BODY = '#MarlopCartBody';
  var timerId = null;

  function root() { return document.querySelector(ROOT); }
  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }
  function sectionId() {
    var r = root();
    return (r && r.dataset.sectionId) ? r.dataset.sectionId : 'cart-drawer';
  }

  function openCart() {
    var r = root();
    if (!r) return;
    r.classList.add('is-open');
    document.documentElement.classList.add('mcart-locked');
    document.body.classList.add('mcart-locked');
    startTimer();
  }
  function closeCart() {
    var r = root();
    if (!r) return;
    r.classList.remove('is-open');
    document.documentElement.classList.remove('mcart-locked');
    document.body.classList.remove('mcart-locked');
  }
  function busy(on) {
    var b = document.querySelector(BODY);
    if (b) b.classList.toggle('mcart__busy', !!on);
  }

  function innerOf(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  function refresh(done) {
    var id = sectionId();
    fetch(routeRoot() + '?sections=' + encodeURIComponent(id) + ',cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var mine = data[id];
        if (mine) {
          var fresh = innerOf(mine, BODY);
          var cur = document.querySelector(BODY);
          if (fresh !== null && cur) cur.innerHTML = fresh;
        }
        var bub = data['cart-icon-bubble'];
        if (bub) {
          var target = document.getElementById('cart-icon-bubble');
          var markup = innerOf(bub, '#shopify-section-cart-icon-bubble');
          if (target && markup !== null) target.innerHTML = markup;
        }
        startTimer();
        busy(false);
        if (done) done();
      })
      .catch(function () { busy(false); if (done) done(); });
  }

  function changeLine(line, quantity) {
    busy(true);
    fetch(routeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { refresh(); }).catch(function () { busy(false); });
  }

  function lineOf(el) {
    var item = el.closest('.mcart__item');
    return item ? parseInt(item.getAttribute('data-line'), 10) : 0;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    fetch(routeRoot() + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { refresh(openCart); })
      .catch(function () { refresh(openCart); });
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('#cart-icon-bubble, .header__icon--cart');
    if (opener) { e.preventDefault(); openCart(); return; }

    if (t.closest('[data-mcart-close]')) { e.preventDefault(); closeCart(); return; }

    var qtyBtn = t.closest('[data-mcart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var step = parseInt(qtyBtn.getAttribute('data-mcart-qty'), 10);
      var input = qtyBtn.parentElement.querySelector('[data-mcart-qty-input]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      changeLine(lineOf(qtyBtn), next);
      return;
    }

    var rm = t.closest('[data-mcart-remove]');
    if (rm) { e.preventDefault(); changeLine(lineOf(rm), 0); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-mcart-qty-input]')) return;
    changeLine(lineOf(input), Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var r = root();
    if (r && r.classList.contains('is-open')) closeCart();
  });

  function readDeadline(minutes) {
    var key = 'marlop-cart-deadline';
    var now = Date.now();
    var dl = 0;
    try { dl = parseInt(window.sessionStorage.getItem(key), 10) || 0; } catch (err) { dl = 0; }
    if (!dl || dl <= now) {
      dl = now + minutes * 60000;
      try { window.sessionStorage.setItem(key, String(dl)); } catch (err) {}
    }
    return dl;
  }

  function startTimer() {
    if (timerId) { clearInterval(timerId); timerId = null; }
    var el = document.querySelector('[data-mcart-timer]');
    if (!el) return;
    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var deadline = readDeadline(minutes);
    var paint = function () {
      var node = document.querySelector('[data-mcart-timer]');
      if (!node) { clearInterval(timerId); timerId = null; return; }
      var left = Math.max(0, Math.round((deadline - Date.now()) / 1000));
      var m = Math.floor(left / 60);
      var sec = left % 60;
      node.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
      if (left <= 0) { clearInterval(timerId); timerId = null; }
    };
    paint();
    timerId = setInterval(paint, 1000);
  }

  if (document.readyState !== 'loading') startTimer();
  else document.addEventListener('DOMContentLoaded', startTimer);
})();
